export default __webpack_public_path__ + "static/media/hakiranje.a216cd35.gif";